import React, {useState} from "react";
import styles from "./popup.module.scss";

const imagePath = "/static-official/images/";
const shownKey = "xiniu_10_year_popup_shown";
// 10周年弹窗已下架，保留代码，需要重新开启时改为 true
const enabled = true;

export default function IndexPopup() {
  const [visible, setVisible] = useState(() => {
    if (!enabled) {
      return false;
    }
    const hasShown = sessionStorage.getItem(shownKey) === "1";
    sessionStorage.setItem(shownKey, "1");
    return !hasShown;
  });

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.mask}>
      <div className={styles.popup}>
        <picture className={styles.bg}>
          <source srcSet={`${imagePath}popup_xiniu_capital_mind.webp`} type="image/webp" />
          <img src={`${imagePath}popup_xiniu_capital_mind.png`} alt="烯牛10周年，AI启新篇" />
        </picture>
        <button className={styles.openBtn} type="button" onClick={() => window.open("https://u1h01mbv.jsjform.com/f/I9JQzt", "_blank", "noopener,noreferrer")}>
          <img src={`${imagePath}popup_xiniu_capital_mind_btn.png`} alt="烯牛开放平台" />
        </button>
        <button className={styles.closeBtn} type="button" onClick={() => setVisible(false)} aria-label="关闭">
          <img src={`${imagePath}popup_xiniu_capital_mind_close.png`} alt="" />
        </button>
      </div>
    </div>
  );
}
